<template>
  <div class="stakeholders-preview-zoom">
    <div
      v-if="storeStakeholder.isZoomTimeCurveLoading"
      class="stakeholders-preview-zoom__loader"
    >
      <MinerveOrbite :taille="96" />
    </div>

    <div v-else-if="isZoomTimeCurveEmpty()" class="card">
      <EmptyChart />
    </div>

    <StakeholdersZoomTimeCurve v-else />
  </div>
</template>

<script setup>
import StakeholdersZoomTimeCurve from "@follaw-fr/components/social-media/stakeholders/organisms/StakeholdersZoomTimeCurve.vue";
import EmptyChart from "@follaw-fr/components/reusable/molecules/EmptyChart.vue";
import MinerveOrbite from "@follaw-fr/components/reusable/minerve/MinerveOrbite.vue";

import { useStakeholdersStore } from "@follaw-fr/stores/social-media/stakeholders";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const userSettingsStore = useUserSettingsStore();
const storeStakeholder = useStakeholdersStore();

const isZoomTimeCurveEmpty = () =>
  storeStakeholder.zoomTimeCurve &&
  Object.values(storeStakeholder.zoomTimeCurve).every(
    (value) => value === null
  );

if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  storeStakeholder.getZoomedAuthorTimeCurve();
}
</script>

<style scoped lang="scss">
.stakeholders-preview-zoom {
  display: grid;
  gap: 8px;

  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
</style>
